window.Met = window.Met || {}
window.Met.map = {};
window.Met.map.isSingleElement = false;

const mapWrapper = document.getElementById('map');

if (mapWrapper && mapWrapper.hasAttribute('data-target')) {
    window.Met.map.mapType = mapWrapper.getAttribute('data-target');
    import (`./${ window.Met.map.mapType}`);
}
